import script from "./remind.vue?vue&type=script&setup=true&lang=js"
export * from "./remind.vue?vue&type=script&setup=true&lang=js"

import "./remind.vue?vue&type=style&index=0&id=4a019420&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a019420"]])

export default __exports__